import { useQuery } from '@tanstack/react-query';

import { OfficeSearchApiResponse } from '@src/lib/__generated/api';
import restfulClient from '@src/utils/restfulClient';

export async function fetchFacilityLocations(params) {
	const route = `v1/facility-locations?` + new URLSearchParams(params).toString();
	try {
		const data: OfficeSearchApiResponse[] = await restfulClient.get({ route });
		const facilitiesOnP3 = data.filter((facility) => facility.onP3);
		return facilitiesOnP3;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(error.message);
		} else {
			throw new Error('Failed to fetch facility locations');
		}
	}
}

export function useGetFacilityLocations(params) {
	const { error, isLoading, isFetching, data } = useQuery<OfficeSearchApiResponse[], Error>({
		queryKey: ['getFacilityLocations', { params }],
		queryFn: () => fetchFacilityLocations(params),
		enabled: Boolean(params.longitude && params.latitude),
	});
	return { error, isLoading, isFetching, data };
}
